export default __webpack_public_path__ + "static/media/Gruesome_3@2x.ab703115.jpg";